export default __webpack_public_path__ + "static/media/640_private01-it-web.9a66e87c.png";